import React, { forwardRef } from "react";

import { ActionsMenuButton } from "@/shared/ui";
import { ButtonProps } from "@mui/material";

type CustomActionsButtonProps = {
	/** Whether the related menu is open (rotates chevron, sets aria-expanded) */
	open: boolean;
	/** Click handler that opens the menu */
	handleClick: (event: React.MouseEvent<HTMLElement>) => void;
	/** ID for the button (used by aria-labelledby on the menu) */
	id?: string;
	/** ID of the menu controlled by this button (for aria-controls) */
	menuId?: string;
	/** Optional loading state (disables and shows spinner) */
	loading?: boolean;
} & Omit<ButtonProps, "id" | "onClick" | "endIcon">;

export const CustomActionsButton = forwardRef<
	HTMLButtonElement,
	CustomActionsButtonProps
>(
	(
		{
			open,
			handleClick,
			id = "training-actions-button",
			menuId = "training-actions-menu",
			loading = false,
			children,
			sx,
			...buttonProps
		},
		ref,
	) => {
		return (
			<ActionsMenuButton
				ref={ref}
				open={open}
				handleClick={(event) => handleClick(event)}
				id={id}
				menuId={menuId}
				loading={loading}
				sx={sx}
				{...buttonProps}
			>
				{children}
			</ActionsMenuButton>
		);
	},
);

CustomActionsButton.displayName = "CustomActionsButton";
